var _circle, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalaryamount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#8A90DC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 30,
    height: 30,
    fill: "url(#pattern0_2428_100)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2428_100",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2428_100",
    transform: "scale(0.0333333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2428_100",
    width: 30,
    height: 30,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAABwElEQVR4nO2Wu0oDQRSGEy/BQqy001ewsRR7Ee/Xyktvo/gCWhovYGkv2og2PoHYia0maAzaKhaJinj75MAfHGR3NrsKNvlgYc/sf+bPnpk5m1SqRo3/AsgAU8AukAMedeU0NmkaR98CNPzWdAwoEM0VMKqcOmAFGExiWA+sE581Gdu1D2zYfRzjJKYVspqjFbgDNuOUNxRH52NYmlnFI9VsJN+anjnaU4/uUnPZkt3oyviMbfeGsSRNurJuwIJHPyFNVvGUz9iORxDXMuwBSkAZGFDOeUjOjp73Kt7zGed9JQa6gVuNvQAPwGtITk457YoLPmN7myDegC5p7Kh0AotayzBK0jcpfkpijLrVFtBn3Un6ZqD4F8b5kEl+lvUZmFfOdkSpOxQXkmyuQz2fVlXMeEZjR1Vurl2fsTX8IN7d3uscpxHgIyRnXBpro8akzzijhh/EJ3DsaE80FoRtukb7SukUFC0ONdaEo3hwdD6GpJlzW2gkTnmSsKo52oB7++BEO34b1zmtLpapcq1HH+gF0lUbOz9gOKJJVLh0ymumy0B/bEMXbZIJOx7Ahfp0Wfc2Nu5unD/561OjRuoXfAE8Pq696JK1jgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalaryamount);
export default __webpack_public_path__ + "static/media/salaryamount.421f5454ee7c88b2f6f3efbd96954c53.svg";
export { ForwardRef as ReactComponent };